import { createSelector, createSlice } from '@reduxjs/toolkit';
import { SummarizeMinimizedResponse } from '@/dashboard/services/dashboardApi';
import { RootStateType } from '@/core/store/store';

const COMMON_STORE_KEY = 'common';
type BoardInfoStoreType = {
  name: string;
  number: string;
};

const commonReducerSlice = createSlice({
  name: COMMON_STORE_KEY,
  initialState: {
    counts: {} as SummarizeMinimizedResponse,
    boardInfo: null as null | BoardInfoStoreType,
  },
  reducers: {
    addCounts(state, { payload }) {
      state.counts = {
        ...state.counts,
        ...payload,
      };
    },
    resetCounts(state) {
      state.counts = {};
    },
    addBoardInfo(state, { payload }) {
      state.boardInfo = payload;
    },
    resetBoardInfo(state) {
      state.boardInfo = null;
    },
  },
});

const countsSelector = (state: RootStateType) => state[COMMON_STORE_KEY].counts;

const getCountsByPeriod = (period: string) => (state: RootStateType) => {
  const counts = state[COMMON_STORE_KEY].counts[period];
  return counts;
};

const getBoardInfoFromStore = createSelector(
  (state: RootStateType) => state,
  (state: RootStateType) => {
    const boardInfo = state[COMMON_STORE_KEY].boardInfo;
    if (boardInfo) {
      return {
        ...boardInfo,
        details: `${boardInfo.number} - ${boardInfo.name}`,
      };
    }
    return null;
  },
);

export const { addCounts, resetCounts, addBoardInfo, resetBoardInfo } = commonReducerSlice.actions;
export default commonReducerSlice.reducer;
export { COMMON_STORE_KEY, countsSelector, getCountsByPeriod, getBoardInfoFromStore };
